// extracted by mini-css-extract-plugin
export default {"container":"SkeletonFormLoader_container__0ZekR","buttons":"SkeletonFormLoader_buttons__sNffT","info":"SkeletonFormLoader_info__-cghi"};